const Menu = [
    {
        heading: "Main Navigation",
        translate: "sidebar.heading.HEADER",
    },
    // {
    //     name: "Dashboard",
    //     icon: "icon-speedometer",
    //     path: "/dashboard",
    //     translate: "sidebar.nav.DASHBOARD",
    // },
    {
        name: "Nómina",
        icon: "fas fa-file-invoice-dollar",
        translate: "sidebar.nav.NOMINA_TURNO",
        submenu: [
            {
                name: "Nomina configuración",
                path: "/configuraciones",
                translate: "sidebar.nav.CONFIGURACION",
                permissions: "nominaListarConfiguracion",
            },
            {
                name: "Nomina Turnos",
                path: "/nomina-turnos",
                translate: "sidebar.nav.TURNOS",
                permissions: "nominaListarTurnos",
            },
            {
                name: "Nomina Reglas",
                path: "/reglas",
                translate: "sidebar.nav.TURNOS_REGLAS",
                permissions: "nominaListarReglas",
            },
            {
                name: "Secuencias",
                path: "/secuencias",
                translate: "sidebar.nav.TURNOS_SECUENCIAS",
                permissions: "nominaListarSecuencias",
            },
            {
                name: "Actividades",
                path: "/actividades",
                translate: "sidebar.nav.ACTIVIDADES",
                permissions: "actividadesListar",
            },
            {
                name: "Nomina Cuadro Turnos",
                path: "/cuadro-turnos",
                translate: "sidebar.nav.CUADRO_TURNOS",
                permissions: "nominaListarCuadroTurnos",
            },
            {
                name: "Nomina Horas Extras",
                path: "/horas-extras-nomina",
                translate: "sidebar.nav.HORAS_EXTRAS_NOMINA",
                permissions: "listarHorasExtras",
            },
            {
                name: "GERENTE",
                path: "/gerente",
                translate: "sidebar.nav.GERENTE",
                permissions: "nominaListarGerente",
            },
            {
                name: "Financiera",
                path: "/financiera",
                translate: "sidebar.nav.FINANCIERA",
                permissions: "nominaListarFinanciera",
            },
            {
                name: "Nomina Informes",
                path: "/informes",
                translate: "sidebar.nav.INFORMES",
                permissions: "nominaListarInforme",
            },
        ],
    },
    {
        name: "Usuarios",
        icon: "icon-user",
        translate: "sidebar.nav.USUARIOS",
        submenu: [
            {
                name: "Activas",
                path: "/personasActivas",
                translate: "sidebar.nav.ACTIVAS",
                permissions: "personasListarActivas",
            },
            {
                name: "Inactivas",
                path: "/personasInactivas",
                translate: "sidebar.nav.INACTIVAS",
                permissions: "personasListarInactivas",
            },
        ],
    },
    {
        name: "Mesa De Ayuda",
        icon: "fas fa-headset",
        translate: "sidebar.nav.MESADEAYUDA",
        submenu: [
            {
                name: "Solicitar",
                path: "/solicitudes/ciudades",
                translate: "sidebar.nav.SOLICITAR",
                permissions: "solicitudesCrear",
            },
            {
                name: "Gestionar",
                path: "/gestionarSolicitudes",
                translate: "sidebar.nav.GESTIONAR",
                permissions: "solicitudesListar",
            },
            {
                name: "En Proceso",
                path: "/solicitudesProceso",
                translate: "sidebar.nav.PROCESO",
                permissions: "solicitudesListar",
            },
            {
                name: "Cerrados",
                path: "/solicitudesCerradas",
                translate: "sidebar.nav.CERRADAS",
                permissions: "solicitudesListar",
            },
        ],
    },
    {
        name: "Gestión Humana",
        icon: "fas fa-headset",
        translate: "sidebar.nav.GESTIONHUMANA",
        submenu: [
            {
                name: "Revisión P.Misional",
                path: "/solicitudesMisionalGH",
                translate: "sidebar.nav.MISIONAL",
                permissions: "solicitudesProcesoListar",
            },
            {
                name: "Revisión Administrativa",
                path: "/solicitudesAdministrativaGH",
                translate: "sidebar.nav.ADMINISTRATIVA",
                permissions: "solicitudesCerradasListar",
            },
            {
                name: "Revisión Dirección",
                path: "/solicitudesDireccionGH",
                translate: "sidebar.nav.DIRECCION",
                permissions: "solicitudesDireccionListar",
            },
            {
                name: "Revisión Gerencia",
                path: "/solicitudesGerenciaGH",
                translate: "sidebar.nav.GERENCIA",
                permissions: "solicitudesGerenciaListar",
            },
            {
                name: "En Proceso GH",
                path: "/solicitudesEnProcesoGH",
                translate: "sidebar.nav.PROCESO",
                permissions: "solicitudesEnProcesoGHListar",
            },
        ],
    },
    {
        name: "Reservas",
        icon: "icon-calendar",
        translate: "sidebar.nav.RESERVAS",
        submenu: [
            {
                name: "Reservar",
                path: "/reservas",
                translate: "sidebar.nav.RESERVAR",
                permissions: "reservasCrearReserva",
            },
            {
                name: "Mis Reservas",
                path: "/mis-reservas",
                translate: "sidebar.nav.RESERVAR",
                permissions: "reservasListarReserva",
            },
            {
                name: "Recursos",
                path: "/recursos",
                translate: "sidebar.nav.RECURSOS",
                permissions: "reservasListarRecursos",
            },
        ],
    },
    {
        name: "Administración",
        icon: "fas fa-cog",
        translate: "sidebar.nav.ADMINISTRAR",
        submenu: [
            {
                name: "Sedes",
                path: "/sedes",
                translate: "sidebar.nav.SEDES",
                permissions: "sedesListar",
            },
            {
                name: "Areas",
                path: "/areas",
                translate: "sidebar.nav.AREAS",
                permissions: "areasListar",
            },
            {
                name: "Sub Areas",
                path: "/subAreas",
                translate: "sidebar.nav.SUBAREAS",
                permissions: "subAreasListar",
            },
            {
                name: "Grupos de permisos",
                path: "/gruposPermisos",
                translate: "sidebar.nav.GRUPOS_PERMISOS",
                permissions: "gruposPermisosListar",
            },
            {
                name: "Permisos",
                path: "/permisos",
                translate: "sidebar.nav.PERMISOS",
                permissions: "permisosListar",
            },
            {
                name: "Festivos",
                path: "/festivos",
                translate: "sidebar.nav.FESTIVOS",
                permissions: "festivosListar",
            },
            {
                name: "Tipos de parametros",
                path: "/tipos_parametros",
                translate: "sidebar.nav.TIPOS_PARAMETROS",
                permissions: "listarTiposParametros",
            },
            {
                name: "Parametros",
                path: "/parametros",
                translate: "sidebar.nav.PARAMETROS",
                permissions: "listarParametros",
            },
            {
                name: "Cargos",
                path: "/cargos",
                translate: "sidebar.nav.CARGOS",
                permissions: "cargosListar",
            },
            {
                name: "Versiones Contratos",
                path: "/versiones_contratos",
                translate: "sidebar.nav.VERSIONES_CONTRATOS",
                permissions: "versionesContratosListar",
            },
            {
                name: "Entidades de Salud",
                path: "/entidades_salud",
                translate: "sidebar.nav.ENTIDADES_SALUD",
                permissions: "listarEntidadesSalud",
            },
            {
                name: "Entidades de Pensión",
                path: "/entidades_pension",
                translate: "sidebar.nav.ENTIDADES_PENSION",
                permissions: "listarEntidadesSalud",
            },
        ],
    },
    {
        name: "Requerimientos",
        icon: "far fa-file-code",
        translate: "sidebar.nav.SOFTWARE",
        submenu: [
            {
                name: "Software",
                path: "/software",
                translate: "sidebar.nav.SOFTWARE",
                permissions: "listarSoftware",
            },
        ],
    },
];

/**
 * Agregar campo *permissions* a los menús padres, con el fin de mostrarlos
 * si tiene algún submenú que deba ser mostrado.
 *
 * El array permissions contiene los permisos requeridos por sus submenús,
 * si el usuario tiene permiso de ver alguno de los submenús, entonces
 * el menú padre debe ser renderizado.
 */
Menu.forEach((menu) => {
    if (
        Object.prototype.hasOwnProperty.call(menu, "submenu") &&
        Array.isArray(menu.submenu)
    ) {
        const permissions = menu.submenu
            .map((submenu) => submenu.permissions)
            .filter((permission) => permission != null);

        if (permissions.length > 0) {
            menu.permissions = permissions;
        }
    }
}, {});

export default Menu;
